import { render, staticRenderFns } from "./_loader.vue?vue&type=template&id=aadfde70&lang=html&"
import script from "./_loader.vue?vue&type=script&lang=js&"
export * from "./_loader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports